import React, { Component } from 'react'
import { Container, } from 'reactstrap'
import BranchList from './BranchList'
import './BranchListContainer.css'
import BranchListHeader from "./BranchListHeader"
import RestrictedSection from "../../Components/RestrictedSection"

// Editable, visible default: the list opens showing active branches; the user
// can flip it to false or drop it entirely from the Advanced Filters popover/chips.
const IS_ACTIVE_PRESET = [
    { id: "preset-0", fieldName: "is_active", filterType: "equal", filterValues: "true", editable: true, visible: true },
]

class BranchListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchTerm: null,
            showLoading: false,
            openModal: "",
            refreshRequired: false,
            orderBy: ["name"],
            activeTab: "branches",
            filterValues: {},
            presets: IS_ACTIVE_PRESET,
        }
    }
    setPresets = (presets) => this.setState({ presets })
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        // To change string inputs to boolean because only strings can be passed to html options
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    updateOrder = (string) => {
        let order = [...this.state.orderBy]
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    toggleModal = (modalName) => {
        if (this.state.openModal !== modalName) {
            this.setState({ openModal: modalName })
        } else {
            this.setState({ openModal: "" })
        }
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_branch">
                <Container fluid className="bos-listing-container" >
                    <BranchListHeader
                        activeTab={this.state.activeTab}
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        refreshRequired={this.state.refreshRequired}
                        currentUser={this.props.currentUser}
                        history={this.props.navigate} location={this.props.location}
                        defaultFilters={this.state.filterValues}
                        refetchQuery={() => this.setState({ refetchInsurances: !this.state.refetchInsurances })}
                        presets={this.state.presets}
                        setPresets={this.setPresets}
                        defaultPresets={IS_ACTIVE_PRESET}
                    />
                    <BranchList
                        currentUser={this.props.currentUser}
                        searchTerm={this.state.filterValues ? this.state.filterValues.searchTerm : null}
                        orderBy={this.state.orderBy}
                        updateOrder={this.updateOrder}
                        presets={this.state.presets}
                    />
                </Container>
            </RestrictedSection>
        )
    }
}



export default BranchListContainer

